var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5777 15.7804L16.7059 2.91794C16.6132 2.82508 16.5031 2.75141 16.3819 2.70114C16.2607 2.65087 16.1308 2.625 15.9996 2.625C15.8684 2.625 15.7385 2.65087 15.6173 2.70114C15.4961 2.75141 15.386 2.82508 15.2934 2.91794L2.42148 15.7804C2.04648 16.1554 1.83398 16.6648 1.83398 17.1961C1.83398 18.2992 2.73086 19.1961 3.83398 19.1961H5.19023V28.3742C5.19023 28.9273 5.63711 29.3742 6.19023 29.3742H13.9996V22.3742H17.4996V29.3742H25.809C26.3621 29.3742 26.809 28.9273 26.809 28.3742V19.1961H28.1652C28.6965 19.1961 29.2059 18.9867 29.5809 18.6086C30.359 17.8273 30.359 16.5617 29.5777 15.7804Z",
    fill: "url(#paint0_linear_3164_59273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3164_59273",
    x1: 2.7894,
    y1: -7.26062,
    x2: 32.4123,
    y2: -6.28683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.45991246501f50fae568434eb7d6c25b.svg";
export { ForwardRef as ReactComponent };